import { Injectable } from '@angular/core';
import { CFHttpClient } from 'app/shared/cf-http-client';
import { UserSession } from '@mem-shared/user-session';
import { UpdateElectronicCommunicationInfo } from './models/update-profile-model';
import { UpdateCriteriaObject } from './models/update-profile-model';
import { UtilService } from '@mem-shared/util.service';
import { HttpHeaders } from '@angular/common/http';
import {environment} from '../../../environments/environment';

// constants for service calls 
const updateMemberCommunicationInfoUrl = environment.serviceSecuredURLs.updateMemberCommunicationInfoURL; //'/mas/sec/updateMemberCommunicationInfo.json';
const  confirmPhoneNumberUrl  =   environment.serviceSecuredURLs.confirmPhoneNumberURL;//'/mas/sec/confirmPhoneNumber.json';
const reSendPhoneActivationCodeUrl = environment.serviceSecuredURLs.reSendPhoneActivationCodeURL;//'/mas/sec/reSendPhoneActivationCode.json';
const reSendEmailActivationCodeUrl = environment.serviceSecuredURLs.reSendEmailActivationCodeURL;//'/mas/sec/reSendEmailActivationCode.json';
const updateMultifactorAuthUrl = environment.servicePublicURLs.updateMultifactorAuthURL; //'/mas/mfa/updateMultifactorAuth.json';



@Injectable()
export class UpdateProfileService {
  
 isConsentUpdateSuccessful: boolean;

  constructor(
    private http: CFHttpClient,
    private userSession: UserSession,
    private utilService: UtilService
  ) { }

  /**
   * This service call is used to update member's profile details
   *
   */

  updateMemberCommunicationInfo(newEmail: UpdateElectronicCommunicationInfo, responseRecordType: string[]) {
    const Params = {
      accountId: this.userSession.getCurrentAccountId(),
      responseRecordType: responseRecordType,
      updateElectronicCommunicationInfo: newEmail
    };
    return this.http.post(updateMemberCommunicationInfoUrl, Params);
  }
  /**
   * This service call is used to confirm phone number
   *
   */
  confirmPhoneNumberUrl(verificationCodeReceived:  String) {
    const  params = {
      accountId: this.userSession.getCurrentAccountId(),
      verificationCode: verificationCodeReceived,
      // user id is obtained from cookies
      userId: this.userSession.getCookie('theUserID'),
      memberId: this.userSession.getMemberAccountDetails().memberKey.subscriberId
    }
    return  this.http.post(confirmPhoneNumberUrl, params);
  }
  /**
 * This service call is used to resend activation code for phone number
 *
 */
  resendPhoneActivationCode() {
    return this.http.get(reSendPhoneActivationCodeUrl);
  }
  /**
* This service call is used to resend activation code for email address
*
*/
  resendEmailActivationCode(emailReceived: String) {
    const params = {
      emailId: emailReceived
    };
    return this.http.get(reSendEmailActivationCodeUrl, params);
  }
  /**
 * This service call is used for multifactor authentication
 *
 */
  updateMultifactorAuth(consentVal: string,sourceRecieved:string) {
    const params = {
      accountId: this.userSession.getCurrentAccountId(),
      mfaConsent: consentVal,
      source : sourceRecieved
    };
    const  httpOptions = {
      headers: this.setHeaders()
    }
    return this.http.post(updateMultifactorAuthUrl, params, httpOptions);
  }

    /**
   * SBS is looking for some additional headers
   * See SBS code:
   * MemberWeb/src/main/com/carefirst/member/present/filters/MemberAuthenticationFilter.java
   */
  protected setHeaders(existingHeaders?) {
    return new HttpHeaders()
      .set('nativeOS', this.utilService.getNativeOS())
      .set('device', this.utilService.getDeviceType());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/update-profile/update-profile.service.ts